import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const getVerses = (search: string, page: number, per_page: number) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.VERSES_HTTP_LOADING
    });

    request({
      method: "get",
      pathname: "getVerses",
      params: { search, page, per_page }
    })
      .then((response) => {
        dispatch({
          type: actions.VERSES_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });

        dispatch({
          type: actions.SET_VERSES_DETAILS,
          payload: {
            ...response.data.content
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.VERSES_HTTP_ERROR, error, dispatch);
      });
  };
};
